import { AssessmentSummaryCoreBase } from "./assessment-summary.core.base"


export class AssessmentSummaryCore extends AssessmentSummaryCoreBase {

}